import React from 'react'

export default ({technicians, technicianServiceSummaries}) => {
  if (technicians.length) {
    return (
      <div className='service-summaries list'>
        <div className='service-summary card no-bg'>
          { technicians.map( (tech) => (
            <p key={tech.id}>{tech.name} ({technicianServiceSummaries[tech.id].completedCount})</p>
          )) }
        </div>
      </div>
        );
  } else {
    return <span></span>
  }
}



// WEBPACK FOOTER //
// ./src/components/service-summaries/technician-service-summaries.js